import script from "./InviteExternalUsersForm.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteExternalUsersForm.vue?vue&type=script&setup=true&lang=js"

import "./InviteExternalUsersForm.vue?vue&type=style&index=0&id=5c585b6a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c585b6a"]])

export default __exports__